import { computed, defineComponent } from "vue";
import BProjectsListItemImage from "./BProjectsListItemImage.vue";
import BProjectsListItemName from "./BProjectsListItemName.vue";
import BProjectsListItemDate from "./BProjectsListItemDate.vue";
import BProjectsListItemDevices from "./BProjectsListItemDevices.vue";
import BProjectsListItemDescription from "./BProjectsListItemDescription.vue";
import BProjectsListItemOptions from "./BProjectsListItemOptions.vue";
import BProjectsListItemOwner from "@/pages/projects/BProjectsListItemOwner.vue";
import { ProjectState } from "@/pages/projects/_providers/types/enums/ProjectEnums";
import { useBinMode } from "@/shared/providers/withBinMode/withBinMode";
import DeviceType from "@/types/DeviceType";
export default defineComponent({
    components: {
        BProjectsListItemImage,
        BProjectsListItemName,
        BProjectsListItemDevices,
        BProjectsListItemDescription,
        BProjectsListItemDate,
        BProjectsListItemOptions,
        BProjectsListItemOwner
    },
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    setup(props, { emit }) {
        const followProject = () => emit("follow", props.project);
        const unfollowProject = () => emit("unfollow", props.project);
        const leaveProject = () => emit("leave", props.project);
        const deleteProject = () => emit("delete", props.project);
        const editProject = () => emit("edit", props.project);
        const shareProject = () => emit("share", props.project);
        const temporaryHide = TEMPORARY_HIDE;
        const moveProject = () => emit("move", props.project);
        const restoreProject = () => emit("restore", props.project);
        const { isBinMode } = useBinMode();
        const getDeviceType = computed(() => {
            switch (props.project.projectDeviceType) {
                case 1:
                    return "Lux";
                case 2:
                    return "CellCounter";
                case 3:
                    return "Omni";
                default:
                    return "Unknown";
            }
        });
        const projectLink = computed(() => {
            if (isBinMode.value) {
                return `/trash/project/${props.project.id}/Experiments`;
            }
            else {
                return `/project/${props.project.id}/Experiments?device=${getDeviceType.value}`;
            }
        });
        const isProjectFlagged = computed(() => props.project.activeState === ProjectState.FLAGGED);
        const isProjectPartiallyDeleted = computed(() => props.project.activeState === ProjectState.PARTIALLY_DELETED);
        const totalExperiments = computed(() => props.project.nrOfExperimentsExact +
            props.project.nrOfExperimentsLux +
            props.project.nrOfExperimentsOmni);
        const isOmniProject = computed(() => props.project.projectDeviceType === DeviceType.Omni);
        return {
            temporaryHide,
            isBinMode,
            totalExperiments,
            isProjectFlagged,
            isProjectPartiallyDeleted,
            projectLink,
            isOmniProject,
            deleteProject,
            editProject,
            followProject,
            shareProject,
            leaveProject,
            moveProject,
            unfollowProject,
            restoreProject
        };
    }
});
